const defaultState = () => {
	return {
		milestones: 0,
		progress: 0,
		finished: false,
	}
}

export const state = () => defaultState()

export const mutations = {
	setFinished(state, finished) {
		state.finished = finished
	},

	setMilestones(state, count) {
		state.milestones = count
	},

	setProgress(state, progress) {
		if (progress < 0) progress = 0
		if (progress > state.milestones) progress = state.milestones

		state.progress = progress
	},
}

export const actions = {
	next({ commit, state, dispatch }) {
		commit('setProgress', state.progress + 1)

		if (state.progress === state.milestones) dispatch('finish')
	},

	prev({ commit, state, dispatch }) {
		commit('setProgress', state.progress - 1)

		if (state.progress === state.milestones) dispatch('finish')
	},

	finish({ commit, dispatch }, progress) {
		commit('setFinished', true)

		setTimeout(() => {
			dispatch('destroy')
		}, 1500)
	},

	init({ commit }, { milestones, startProgress = 0 }) {
		commit('setMilestones', milestones)
		commit('setProgress', startProgress)
		commit('setFinished', false)
	},

	destroy({ commit }) {
		commit('setMilestones', 0)
		commit('setProgress', 0)
		commit('setFinished', false)
	},
}
